import StyledComponent from 'styled-components';

import { FormInputType, FormInputTypeEnum } from '../../components/Form/Form.types';

const FORM_INPUT_TYPE_OPTIONS = [
  { text: 'Datetime', value: 'datetime' },
  { text: 'Date', value: 'date' },
  { text: 'Selection', value: 'select' },
  { text: 'File', value: 'file' },
  { text: 'Number', value: 'number' },
  { text: 'Object', value: 'object' },
  { text: 'Reference', value: 'reference' },
  { text: 'Secure Text', value: 'secure' },
  { text: 'Text', value: 'string' },
  { text: 'True/False', value: 'boolean' },
];

const DEFAULT_FORM_INPUTS: FormInputType[] = [
  {
    label: 'Name',
    id: 'name',
    element: 'input',
    type: FormInputTypeEnum.text,
    validation: { requirement: 'A name is required', algorithm: 'range', min: 1, max: 64 },
    required: 'required',
    placeholder: 'Enter a name',
    value: '',
    class: '',
    row: 0,
    col: 0,
  },
  {
    label: 'Type',
    id: 'type',
    element: 'select',
    options: FORM_INPUT_TYPE_OPTIONS,
    value: '',
    class: '',
    placeholder: '',
    row: 0,
    col: 0,
    type: FormInputTypeEnum.select,
    required: '',
  },
];

const Container = StyledComponent.div`
			.main-btn-section, .bottom-btn-section
			{
				margin-bottom: 25px;
				margin-top: 8px;
				justify-content: space-between;
		    display: flex;
			}
			.bottom-btn-section
			{
				margin-bottom: 0px;
				margin-top: 50px;
				justify-content: space-between;
		    display: flex;
			}
			.schema-name
			{
				width: 100%;
				margin-top: 10px;
			}
			.schema-list
			{
				margin-top: 25px;
			}
			.table-properties-btn
			{
				margin-top: 15px;
			}
			.admin-table-properties
			{
				margin-top: 15px;
				width: 100%;
			}
			.table-properties
			{
				margin-top: 15px;
				width: 100%;
				font-size: 10px;

				textarea
				{
					white-space: pre-line;
				}
			}
			.schema-btns
			{
				margin-bottom: 10px;
			}
			.schema-form
			{
				margin-top: 15px;
			}
			.model-list
			{
				margin-top: 15px;

				h1
				{
					text-align: left;
				}
				h2
				{
					text-align: left;
					color: black;
				}
			}
			.MuiChip-outlinedPrimary
			{
				width: 100%;
				margin-top: 10px;
			}
		`;

export { FORM_INPUT_TYPE_OPTIONS, DEFAULT_FORM_INPUTS, Container };
